import { observable, action, makeObservable, autorun } from 'mobx';
import { sessionStorage } from 'js-storage';

function getProductFromHash() {
  const hash = window.location.hash; // #/gxv3450/settings
  return hash.match(/^#\/([^/]+)\//)?.[1]?.toLocaleLowerCase() || '';
}
class ProductStore {
  constructor() {
    makeObservable(this);
  }

  @observable
  current: Product =
    sessionStorage.get('guiconfig_product') || getProductFromHash() || '';

  @action.bound
  setProduct(p: Product) {
    this.current = p;
  }

  @observable
  ts: number = new Date().getTime();

  @action.bound
  updateTs() {
    this.ts = new Date().getTime();
  }
}

const productStore = new ProductStore();

autorun(() => {
  sessionStorage.set('guiconfig_product', productStore.current);
});

export default productStore;
